<template>
<div style=" padding:20px;margin-top:10px;background: #fff;  ">
 <el-form ref="form" :model="form" v-loading="loading" label-width="80px" style="margin: 50px">
  <el-form-item label="手机" required>
    <el-input v-model="form.tel" readonly></el-input>
  </el-form-item>
 <el-form-item label="用户名" >
    <el-input v-model="form.name"></el-input>
  </el-form-item>
  <el-form-item label="邮箱" >
    <el-input v-model="form.email"></el-input>
  </el-form-item>

  <el-form-item label="公司名称">
     <el-input v-model="form.company"></el-input>
  </el-form-item>
  <el-form-item label="生日">
    <el-date-picker
      v-model="form.birthday"
      type="date" 
	  value-format="yyyy-MM-dd" 
      placeholder="选择日期">
    </el-date-picker>
  </el-form-item>
  <el-form-item label="性别">
    <el-radio-group v-model="form.gender">
      <el-radio label="男"></el-radio>
      <el-radio label="女"></el-radio>
    </el-radio-group>
  </el-form-item>
 
  <el-form-item>
    <el-button type="primary" :loading="is_loading" @click="onSubmit" >保存</el-button>
    <el-button @click="getInfo">取消</el-button>
	
  </el-form-item>
</el-form>
</div>
</template>
 
<script>
export default  {
    data() {
      return {
	    is_loading: false,
		loading: true,
        form: {
          name: '',
		  tel: '',
		  email: '',
		  company: '',
          region: '',
          birthday: '',
          gender: '',
          delivery: false,
          type: [],
          resource: '',
          desc: ''
        }
      }
    },

    methods: {
	  getInfo(){
 
	    let that = this;
	    let userInfo = localStorage.getItem('userInfo');
		let info = JSON.parse(userInfo);
		let id = info.id;
        console.log( userInfo);  
		  $.ajax({
              type: "GET",
			  data:  {id: info.id},
              url: "https://www.myferp.com/admin/user/info",
              dataType: "json",  //返回类型为 json
              beforeSend: function (request) {
                request.setRequestHeader("X-Nideshop-Token", localStorage.getItem('token') );
                },   
              error: function(XMLHttpRequest, textStatus, errorThrown) { 
 		          that.loading = false;
			      that.$message({
                    message: data,
                    type: 'error'
                    });
                        return false;
                    },             
              success: function (data) {
		        
				console.log(JSON.stringify(data));
				that.form.name = data.data.user_nickname;
                that.form.tel = data.data.user_phone;
                that.form.email = data.data.user_email;
				that.form.birthday = data.data.birthday;
				that.form.company = data.data.companyName;
                that.form.gender = data.data.gender;	
                that.loading = false;				
                }
              });	
	  },
	  
      onSubmit() { 
	    let that = this;
	    let userInfo = localStorage.getItem('userInfo');
		let info = JSON.parse(userInfo);
		let id = info.id; 
		that.is_loading = true;
        console.log(that.form.birthday);  
		  $.ajax({
              type: "POST",
			  data: {id: info.id, 
			      nickname: that.form.name, 
				  tel: that.form.tel, 
				  email: that.form.email,
				  birthday: that.form.birthday,
				  gender: that.form.gender,
				  company: that.form.company} ,
              url: "https://www.myferp.com/admin/user/updateInfo",
              dataType: "json",  //返回类型为 json
              beforeSend: function (request) {
                request.setRequestHeader("X-Nideshop-Token", localStorage.getItem('token') );
                },   
              error: function(XMLHttpRequest, textStatus, errorThrown) { 
 		          that.is_loading = false;
			      that.$message({
                    message: data,
                    type: 'error'
                    });
                        return false;
                    },             
              success: function (data) {
		        that.is_loading = false;
				console.log(JSON.stringify(data));
				that.$message({
                  message: '保存成功',
                  type: 'success'
                  });
                }
              });	
			 
			     
      }
    },
    mounted() {
	  this.getInfo();
	},
  }
</script>
 
 


// WEBPACK FOOTER //
// src/components/setting/info.vue